import { iconEdit } from '@cube3/ui/src/icons/GeneralSVG';
import { ButtonFactory, ButtonFactoryConfig } from '../../useButtonConfig';
import { archivedProjectTooltip, readOnlyProjectTooltip } from '../tooltip';

/** Asset level edit metadata button */

export const MetadataEditButtonFactory = (
  onClick: () => void = () => {},
  title?: string
): ButtonFactory => {
  const f = (config: ButtonFactoryConfig) => {
    const { canEditMetadata } = config.privileges;
    const { isProjectArchived, isProjectRoleReadOnly } = config;
    const disabledReason = (() => {
      switch (true) {
        case !canEditMetadata:
          return 'This account has no permission to edit metadata';
        case isProjectRoleReadOnly:
          return readOnlyProjectTooltip;
        case isProjectArchived:
          return archivedProjectTooltip;
        default:
          return undefined;
      }
    })();
    return {
      title: title || 'Edit',
      visible: true,
      disabled: !canEditMetadata || isProjectArchived || isProjectRoleReadOnly,
      disabledReason,
      icon: iconEdit,
      onClick: onClick
    };
  };

  return {
    factory: f
  };
};
